import { Component, EventEmitter, Output, Input } from '@angular/core';
import { NgForm } from '@angular/forms';
import { compare } from "bcrypt-ts";
import { HttpClient, HttpParams } from '@angular/common/http';
import { User } from '../Models/User';
import { firstValueFrom, lastValueFrom } from 'rxjs';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrl: './login.component.css',
  standalone: false
})
export class LoginComponent {

  @Output()
  loggedInUser = new EventEmitter<User | undefined>();

  constructor(private http: HttpClient) { }

  public user: User | undefined = undefined;
  public loginError = false;


  async loginFromForm(loginForm: NgForm) {

    if (loginForm.invalid) return;

    await this.login(
      loginForm.value["username"],
      loginForm.value["password"]
    );
  }


  async login(username: string, password: string) {

    this.loginError = false;

    try {

      const response = await lastValueFrom(
        this.http.post<User>('/charitycentral/login', {
          username,
          password
        })
      );

      this.user = response;
      this.loggedInUser.emit(this.user);

    } catch {
      this.loginError = true;
    }
  }
}
